"use strict";

// Tracks clicks in the main navigation and pushes a structured dataLayer event
// Expected data attributes on <a> elements:
// - data-event-tracking-category="click_main_navigation" (used to scope listeners)
// - data-tracking-main: label of the main item (level 1)
// - data-tracking-sub: label of the sub item (level 2) — optional
// - data-tracking-selected: label of the clicked item

export function initInScope($scope) {
    const selector = 'a[data-event-tracking-category="click_main_navigation"]';

    $scope.find(selector).off('click.navTracking').on('click.navTracking', function () {
        try {
            const $el = $(this);

            const mainItem = $el.data('tracking-main') || ($el.text() || '').trim();
            const subItem = $el.data('tracking-sub');
            const selectedItem = $el.data('tracking-selected') || ($el.text() || '').trim();

            const data = {
                event: 'click_main_navigation',
                main_item: mainItem || undefined,
                sub_item: (subItem !== '' ? subItem : undefined),
                selected_item: selectedItem || undefined
            };

            if (typeof window.dataLayer !== 'undefined' && Array.isArray(window.dataLayer)) {
                window.dataLayer.push(data);
            }
        } catch (e) {
            // fail silently to avoid breaking navigation
            if (window && window.console && console.warn) {
                console.warn('navTracking error', e);
            }
        }
    });
}
